import { render, staticRenderFns } from "./btTrends.vue?vue&type=template&id=01515e5a&"
import script from "./btTrends.vue?vue&type=script&lang=js&"
export * from "./btTrends.vue?vue&type=script&lang=js&"
import style0 from "./btTrends.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports